<template lang="pug">
#allsports.modal.modal-common.animated.fadeInUp1.modal-bottom(tabindex="-1" role="dialog" aria-labelledby="langLabel" aria-hidden="true")
  .modal-dialog.modal-dialog-scrollable.m-0(role="document" style="height:70%;")
    .modal-content
      .modal-header(data-dismiss="modal" :aria-label="$t('ui.cancel')")
        .icon
          i.fas.fa-arrow-left
        h5#exampleModalLabel.modal-title {{ $t("ui.all_sports") }}
      .modal-body.py-1.px-0
        .row.mx-1
          template(v-for="(sport, index) in order")
            template(v-if="!defaultExclude.includes(sport)")
              .col-6.p-1(v-if="todayMenu[sport] && todayMenu[sport].tn > 0 || earlyMenu[sport] && earlyMenu[sport].tn > 0 || liveMenu[sport] && liveMenu[sport].tn > 0")
                a.d-block(href="javascript:void(0);" @click="setMenu2x(sport)")
                  .sport-wrap(style="margin: auto;")
                    .flex-grow-1.pr-1
                      img(:src="'/images/icon-sport-svg/' + getSportsImage(sport)", width='25' height='25')
                    .text {{ sportsName[sport] }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import toolBar from "@/components/mobile/toolBar";
import footerNav from "@/components/mobile/footerNav";
import config from "@/config";
import mixinTypes from "@/library/mixinTypes";

export default {
  components: {
    toolBar,
    footerNav
  },
  mixins: [mixinTypes],
  data() {
    return {
      loading: false
    };
  },
  computed: {
    menu1() {
      return this.$store.getters.menu1;
    },
    order() {
      return this.$store.state.layout.order.sports;
    },
    sports() {
      return Object.keys(this.$store.state.layout.sports);
    },
    sportsName() {
      return this.$store.state.layout.sports;
    },
    defaultExclude() {
      return config.defaultSportExclude;
    }
  },
  methods: {
    getSportsImage(e) {
      return config.getSportsImage(e);
    },
    clearSearch() {
      this.$store.dispatch("layout/setSearch", null);
    },
    resetSelectLeague() {
      this.$store.dispatch("layout/resetSelectLeague");
    },
    setDays(e) {
      if ([1, 20, 40, 41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53].includes(e)) {
        this.$store.dispatch("layout/setSelectedDays", "1");
      } else {
        this.$store.dispatch("layout/setSelectedDays", "0");
      }
    },
    setMenu2x(e) {
      // $(".btn-parlay").removeClass("active");
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      if (this.menu0 == "parlay") {
        mi5["menu0"] = "parlay";
        mi5["menu1"] = "parlay";
        mi5["menu2"] = parseInt(e);
        mi5["menu3"] = "parlay";
      } else {
        if(this.liveMenu[e] && this.liveMenu[e].tn > 0) {
          mi5["menu0"] = "live";
          mi5["menu1"] = "live";
          mi5["menu2"] = parseInt(e);
          mi5["menu3"] = "hdpou";
          var options = {};
          options[mi5["menu2"]] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: options });
        } else if(this.todayMenu[e] && this.todayMenu[e].tn > 0) {
          mi5["menu0"] = "all";
          mi5["menu1"] = "today";
          mi5["menu2"] = parseInt(e);
          mi5["menu3"] = "hdpou";
        } else if(this.earlyMenu[e] && this.earlyMenu[e].tn > 0) {
          mi5["menu0"] = "all";
          mi5["menu1"] = "early";
          mi5["menu2"] = parseInt(e);
          mi5["menu3"] = "hdpou";
        }
        // console.log(this.todayMenu[e], this.todayMenu[e] && this.todayMenu[e].tn > 0)
        // console.log(this.liveMenu[e], this.liveMenu[e] && this.liveMenu[e].tn > 0)
        // if(this.todayMenu[e] && this.todayMenu[e].tn > 0) {
        //   mi5["menu0"] = "all";
        //   mi5["menu1"] = "today";
        //   mi5["menu2"] = parseInt(e);
        //   mi5["menu3"] = "hdpou";
        // } else {
        //   mi5["menu0"] = "live";
        //   mi5["menu1"] = "live";
        //   mi5["menu2"] = parseInt(e);
        //   mi5["menu3"] = "hdpou";
        //   var options = {};
        //   options[mi5["menu2"]] = true;
        //   this.$store.dispatch("layout/setOptions", { property: "live", value: options });
        // }
      }

      var changed = false;
      if (mi5["menuX"] != this.menuX) {
        changed = true;
      }
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }

      if (changed) {
        this.setDays(parseInt(mi5["menu2"]));
        this.resetSelectLeague();
        this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }
      $("#allsports").modal("hide");
      this.$router.push("/prematch").catch(err => {});
    }
  }
};
</script>
